import gql from 'graphql-tag';

const DELETE_SEGMENT = gql`
  mutation deleteSegment($memberId: Int!, $segmentId: Int!) {
    deleteSegment(where: { member_id: $memberId, segment_id: $segmentId })
  }
`;

export default DELETE_SEGMENT;
